import { createAsyncThunk } from "@reduxjs/toolkit";
import { getUploadsList, getUploadsStats } from "../../services/apiV2";
import { TGetUploadsListPayload } from "../../services/apiV2.types";
import { RootState } from "../../store/store";

export const getBulkAnalyzerUploadedFiles = createAsyncThunk(
  "bulkAnalyzerFiles/getBulkAnalyzerUploadedFiles",
  async (req: TGetUploadsListPayload, { rejectWithValue }) => {
    try {
      const { page, perPage } = req;
      /**
       * The actual page in state must start with 0, but the API request requires it to start from 1.
       * So keep page 0 for cache and page + 1 for the API
       */
      const res = await getUploadsList({ page: page + 1, perPage });
      return res;
    } catch (e) {
      return rejectWithValue(e);
    }
  },
  {
    condition: (
      { page, perPage, forceRefetch }: TGetUploadsListPayload,
      { getState },
    ) => {
      if (forceRefetch) return true;
      const state = getState() as RootState;
      const { files, total } = state.bulkAnalyzerFiles;
      if (total && files.length === total) return false;
      return files.length < (page + 1) * perPage;
    },
  },
);

export const getBulkAnalyzerUploadsStats = createAsyncThunk(
  "bulkAnalyzerFiles/getBulkAnalyzerUploadsStats",
  async (_, { rejectWithValue }) => {
    try {
      return await getUploadsStats();
    } catch (e) {
      return rejectWithValue(e);
    }
  },
);
